import { makeObservable } from 'mobx'
import moment from 'moment'
import { isAdmin, isDealer, isOperator } from '../../../services/AccountService'
import FormStore from '../../../utils/stores/FormStore'

const initState = {
  orderId: '',
  receiverSerialNumber: '',
  receiverModelId: '',
  dateOfMaintenance: '',
  files: null,
  diagnosticPassBasisComment: '',
  replacedReceiverModelId: '',
  replacedReceiverSerialNumber: '',
  equipmentId: '',
  workDescription: '',
  dateOfVisit: '',
  visitDescription: '',
}

const validateDataTemplate = {
  orderId: { required: true },
  receiverSerialNumber: { required: true },
  receiverModelId: { required: true },
  dateOfMaintenance: {
    required: true,
    validators: [
      (value) => value.length < 8,
      (value) => {
        return (
          moment().utc(true).diff(moment(value, 'DD-MM-YYYY').utc(true)) < 0 &&
          moment(value, 'DD-MM-YYYY').isAfter(moment())
        )
      },
    ],
  },
  dateOfVisit: {
    required: true,
    validators: [
      (value) => value.length < 8,
      (value) => {
        return (
          moment().utc(true).diff(moment(value, 'DD-MM-YYYY').utc(true)) < 0 &&
          moment(value, 'DD-MM-YYYY').isAfter(moment())
        )
      },
    ],
  },
  diagnosticPassBasisComment: { required: true },
}

const noValidateDataTemplate = {
  dateOfMaintenance: {
    required: true,
    validators: [
      (value) => value.length < 8,
      (value) => {
        return (
          moment().utc(true).diff(moment(value, 'DD-MM-YYYY').utc(true)) < 0 &&
          moment(value, 'DD-MM-YYYY').isAfter(moment())
        )
      },
    ],
  },
  diagnosticPassBasisComment: { required: true },
}

class ServiceInformationAccordionFormStore extends FormStore {
  constructor() {
    const validateData = { ...validateDataTemplate }

    if (!(isDealer() || isAdmin())) {
      validateData.files = { required: true }
      validateData.receiverSerialNumber = { required: true }
      validateData.receiverModelId = { required: true }
    } else if (isOperator() || isAdmin()) {
      validateData.receiverModelId = { required: true }
      validateData.receiverSerialNumber = { required: true }
    }
    super({ initState, validateData })
    this.showErrors = true
    this.isValid = false
    makeObservable(this, {})
  }

  isFiveStatus = () => true

  resetValidation = () => {
    this.initValidateData(noValidateDataTemplate)
  }

  backValidation = () => {
    const validateData = { ...validateDataTemplate }
    if (!(isDealer() || isAdmin())) {
      validateData.files = { required: true }
      validateData.receiverSerialNumber = { required: true }
      validateData.receiverModelId = { required: true }
    } else if (isOperator() || isAdmin()) {
      validateData.receiverModelId = { required: true }
      validateData.receiverSerialNumber = { required: true }
    }

    this.initValidateData(validateData)
  }

  clear = () => {
    this.setData(initState)
    this.clearSelectedFilters()
  }
}

export default ServiceInformationAccordionFormStore
